module.exports = __webpack_public_path__ + "static/media/step-indicator-1.b73cf586.svg";